namespace Matrix.Data {
    export interface TestResultForm {
        BatchId: Serenity.IntegerEditor;
        TestCode: Serenity.LookupEditor;
        ResultCode: Serenity.StringEditor;
        FailCount: Serenity.IntegerEditor;
        Message: Serenity.StringEditor;
        ResultData: Serenity.StringEditor;
        ResultTable: TestResultTable;
        CreatedBy: StaticTextBlock;
        CreatedWhen: StaticTextBlock;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: StaticTextBlock;
        Version: StaticTextBlock;
    }

    export class TestResultForm extends Serenity.PrefixedContext {
        static formKey = 'Data.TestResult';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TestResultForm.init)  {
                TestResultForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = TestResultTable;
                var w4 = StaticTextBlock;

                Q.initFormType(TestResultForm, [
                    'BatchId', w0,
                    'TestCode', w1,
                    'ResultCode', w2,
                    'FailCount', w0,
                    'Message', w2,
                    'ResultData', w2,
                    'ResultTable', w3,
                    'CreatedBy', w4,
                    'CreatedWhen', w4,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w4,
                    'Version', w4
                ]);
            }
        }
    }
}
